<nz-layout class="content-section">
  <nz-content>
    <div class="revision-page-container">
      <div class="filters">
        <div class="select-container">
          <label class="select-label">Filter by Percent Change</label>
          <nz-select
            class="border-black"
            [(ngModel)]="gridFilters.percentChange"
            [nzSize]="'small'"
            [nzDropdownClassName]="'filter-select-dropdown'"
            style="width: 150px"
            (ngModelChange)="revisionGrid.onFilterChange(['percentChange'])"
          >
            <nz-option [nzLabel]="'Show All'" [nzValue]="'default'"></nz-option>
            <nz-option [nzLabel]="'More than 2%'" [nzValue]="'2'"></nz-option>
            <nz-option [nzLabel]="'More than 5%'" [nzValue]="'5'"></nz-option>
            <nz-option [nzLabel]="'More than 10%'" [nzValue]="'10'"></nz-option>
          </nz-select>
        </div>
        <div class="select-container">
          <label class="select-label">Revision Start Date</label>
          <nz-select
            class="border-black"
            [(ngModel)]="gridFilters.startDate"
            [nzSize]="'small'"
            [nzDropdownClassName]="'filter-select-dropdown'"
            style="width: 200px"
            (ngModelChange)="onStartDateChange(revisionGrid)"
          >
            <nz-option
              [nzLabel]="'Pre-Q (prior to earnings)'"
              [nzValue]="'PreQ'"
            ></nz-option>
            <nz-option
              [nzLabel]="'Custom date'"
              [nzValue]="'customDate'"
            ></nz-option>
            <nz-option [nzLabel]="'1 Month'" [nzValue]="'-1Month'"></nz-option>
            <nz-option [nzLabel]="'3 Months'" [nzValue]="'-3Month'"></nz-option>
          </nz-select>
        </div>
        <div
          class="select-container"
          *ngIf="gridFilters.startDate === 'customDate'"
        >
          <label class="select-label">Select Custom Date</label>
          <nz-date-picker
            class="border-black"
            [nzSize]="'small'"
            [ngModel]="customDate"
            [nzDisabledDate]="disabledDate"
            (ngModelChange)="revisionGrid.onChangeCustomDate($event)"
          ></nz-date-picker>
        </div>
        <div class="select-container">
          <label class="select-label">Filter</label>
          <nz-input-group
            class="border-black"
            [nzSuffix]="clearSuffixTemplate"
            [nzSize]="'small'"
            class="revision-search-filter"
          >
            <input
              [(ngModel)]="gridFilters.filterLineItem"
              nz-input
              placeholder="Search"
              (keyup)="revisionGrid.onFilterChange(['lineitem'])"
            />
          </nz-input-group>
          <ng-template #clearSuffixTemplate
            ><i
              nz-icon
              nz-tooltip
              class="ant-input-clear-icon"
              nzTheme="fill"
              nzType="close-circle"
              *ngIf="gridFilters.filterLineItem"
              (click)="onClearLineitemSearch(revisionGrid)"
            ></i
          ></ng-template>
        </div>
        <div
          class="show-more-periods"
          [class.disabled]="
            revisionMeta.periods &&
            revisionMeta.periods[revisionMeta.periods.length - 1].includes(
              revisionMeta.end_fiscal + ''
            )
          "
        >
          <a (click)="revisionGrid.onShowMorePeriodsClicked()"
            >Show More Periods</a
          >
        </div>
        <div class="yoy-switches">
          <div class="show-yoy">
            Show YoY%
            <nz-switch
              [ngModel]="gridFilters.showYoyPercent"
              (ngModelChange)="onFilterChange($event, 'showYoyPercent')"
            ></nz-switch>
          </div>
          <div
            class="show-only-yoy"
            [attr.disabled]="gridFilters.showYoyPercent ? true : null"
          >
            Show only % change
            <nz-switch
              [ngModel]="gridFilters.onlyPercentChange"
              (ngModelChange)="onFilterChange($event, 'onlyPercentChange')"
            ></nz-switch>
          </div>
        </div>
      </div>
      <app-revision-grid
        #revisionGrid
        [revisionMeta]="revisionMeta"
        [gridFilters]="gridFilters"
      ></app-revision-grid>
    </div>
  </nz-content>
  <nz-sider
    [hidden]="!showRightSidebar"
    [ngClass]="!disabledSidebar ? 'rightSider' : 'rightSider disabled'"
    nzTheme="light"
    nzCollapsible
    [(nzCollapsed)]="isRightsideBarCollapsed"
    [nzCollapsedWidth]="0"
    [nzZeroTrigger]="rightSiderArrowTemplate"
    (nzCollapsedChange)="rightSiderCollapseChanged($event)"
  >
    <app-right-panel></app-right-panel>
  </nz-sider>

  <ng-template #rightSiderArrowTemplate>
    <va-icon
      name="arrow-circle-left"
      *ngIf="isRightsideBarCollapsed"
      class="fa fa-md"
    ></va-icon>
    <va-icon
      name="arrow-circle-right"
      *ngIf="!isRightsideBarCollapsed"
      class="fa fa-md"
    ></va-icon>
  </ng-template>
</nz-layout>
